import {
  ChangeDetectionStrategy,
  Component,
  input,
  HostBinding,
  computed,
} from '@angular/core';

import { IconType } from '@aksia/infrastructure';
import { UiControlDirective } from '../../../directives/ui/ui-control.directive';

@Component({
  selector: 'icon',
  imports: [],
  templateUrl: './icon.component.html',
  styles: `
    :host {
      * {
        pointer-events: none;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent extends UiControlDirective {
  //#region Inputs/Outputs

  iconDefinition = input<IconType | undefined>(undefined);

  iconSize = input<string | undefined>(undefined);

  iconColor = input<string | undefined>(undefined);

  iconCssClass = input<string | undefined>(undefined);

  renderInGrid = input<boolean | undefined>(undefined);

  //#endregion

  //#region Host Bindings
  @HostBinding('class') get hostIconClass() {
    return this.iconClass();
  }

  //#region properties

  iconClass = computed(
    () =>
      `${this.iconSize() ?? ''} ${this.iconColor() ?? ''} ${this.iconDefinition() ?? ''} ${this.iconCssClass() ?? ''}`,
  );

  //#endregion
}
